import { DeleteOutlined } from '@ant-design/icons';
import { Popconfirm } from 'antd';
import React from 'react';
import { Props } from '.';
import Icon from '../../../../components/icon/Icon';
import {
    CardRequest,
    CardTypeEnum,
    EventVm,
    MatchCoachVm,
    UpdateEventCommand,
} from '../../../../utils/api';

class Card extends React.PureComponent<Props> {
    public handleCardTypeSelect = (cardId: CardTypeEnum): void => {
        const { event, updateEvent } = this.props;

        const eventVm = event as EventVm;

        const card: CardRequest | undefined = new CardRequest({
            ...event.card,
            typeId: cardId,
            id: eventVm.cardId || 0,
        });
        const updatedEvent: UpdateEventCommand = new UpdateEventCommand({
            ...event,
            card,
        });

        updatedEvent.id = event.id;

        updateEvent(updatedEvent);
    };

    public render = (): React.ReactElement => {
        const { event, coaches, clearEvent, deleteEvent, match } = this.props;
        const eventVm = event as EventVm;
        const eventExists = !!eventVm.id;
        const cardType = event.card?.typeId;
        const matchCoach = coaches.find(
            (c: MatchCoachVm): boolean => c.id === event.card?.cardedCoachId
        );

        const isTeamCard = !event.card?.cardedCoachId && !event.card?.cardedPlayerId;
        let teamCaption = '';
        if (isTeamCard && match && event.card?.teamId) {
            teamCaption =
                event.card.teamId === match.homeTeamId
                    ? match.homeTeamDisplayName ?? ''
                    : match.awayTeamDisplayName ?? '';
        }

        return (
            <div className="event-create">
                <div className="c-shot-form__caps-label">{isTeamCard ? 'Team' : 'Coach'}</div>
                <div className="content" style={{ color: '#fff', marginBottom: 8 }}>
                    {isTeamCard
                        ? teamCaption
                        : matchCoach
                        ? `${matchCoach.coach.name} ${matchCoach.coach.surname}`
                        : ''}
                </div>
                <div className="c-shot-form__grid">
                    <div className="c-shot-form__col">
                        <span
                            className={`c-shot-pill${
                                cardType === CardTypeEnum.Yellow ? ' c-shot-pill--active' : ''
                            }`}
                            style={
                                cardType === CardTypeEnum.Yellow
                                    ? { backgroundColor: '#f9a825' }
                                    : undefined
                            }
                            onClick={(): void => this.handleCardTypeSelect(CardTypeEnum.Yellow)}
                            role="button"
                        >
                            Yellow
                        </span>
                    </div>
                    {!isTeamCard && (
                        <div className="c-shot-form__col">
                            <span
                                className={`c-shot-pill${
                                    cardType === CardTypeEnum.Red ? ' c-shot-pill--active' : ''
                                }`}
                                style={
                                    cardType === CardTypeEnum.Red
                                        ? { backgroundColor: '#d32f2f' }
                                        : undefined
                                }
                                onClick={(): void => this.handleCardTypeSelect(CardTypeEnum.Red)}
                                role="button"
                            >
                                Red
                            </span>
                        </div>
                    )}
                    <div className="c-shot-form__actions">
                        <span
                            className="c-shot-form__action-btn"
                            onClick={(): void => clearEvent()}
                            role="button"
                            title="Close"
                        >
                            <Icon name="icon-times" />
                        </span>
                        {eventExists && (
                            <Popconfirm
                                title="Are you sure you want to delete this event?"
                                onConfirm={(): void => deleteEvent(eventVm)}
                                okText="Delete"
                                okButtonProps={{ danger: true }}
                                cancelText="Cancel"
                            >
                                <span
                                    className="c-shot-form__action-btn c-shot-form__action-btn--delete"
                                    role="button"
                                    title="Delete"
                                >
                                    <DeleteOutlined />
                                </span>
                            </Popconfirm>
                        )}
                    </div>
                </div>
            </div>
        );
    };
}

export default Card;
